import React from "react";
import { ReactComponent as TimeLoading } from "../../icons/TimeCommitment.svg";

const TimeCommitmentCard = () => {
  return (
    <div className="w-full max-w-[224px] h-44 bg-white rounded-2xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex flex-col items-center justify-center p-4">
      {/* Animated Icon */}
      <div className="w-16 h-16 flex items-center justify-center animate-pulse">
        <TimeLoading className="w-12 h-12 text-blue-600" />
      </div>

      {/* Label */}
      {/* <p className="mt-4 text-sm font-medium text-gray-700">Time Commitment</p> */}

      {/* Placeholder for new users */}
      <span className="text-xs text-gray-400 italic">Start Grinding</span>
    </div>
  );
};

export default TimeCommitmentCard;
